import { useState, useCallback } from 'react';

export function useViewTransition() {
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [transitionDirection, setTransitionDirection] = useState<'toEditor' | 'toProjects' | null>(null);

    const transitionTo = useCallback(async () => {
        setTransitionDirection('toEditor');
        setIsTransitioning(true);
        await new Promise(r => setTimeout(r, 150));
    }, []);

    const transitionFrom = useCallback(async () => {
        setTransitionDirection('toProjects');
        setIsTransitioning(true);
        await new Promise(r => setTimeout(r, 150));
    }, []);

    const finishTransition = useCallback(() => {
        setTimeout(() => {
            setIsTransitioning(false);
            setTransitionDirection(null);
        }, 300);
    }, []);

    return {
        isTransitioning,
        transitionDirection,
        transitionTo,
        transitionFrom,
        finishTransition,
    };
}
